import { css } from 'styled-components';

export const SIDENAV_DURATION = '0.25s';
export const SIDNAV_EASING = 'ease-in-out';

export const sideNavTransitionProperties = (properties: string[]) => {
  const propertyList = properties.join(', ');

  return css`
    transition-timing-function: ${SIDNAV_EASING};
    transition-duration: ${SIDENAV_DURATION};
    transition-property: ${propertyList};
    transition-behavior: allow-discrete; /* stylelint-disable-line property-no-unknown */

    @media (prefers-reduced-motion) {
      transition: none;
    }
  `;
};
